import { render, staticRenderFns } from "./ModalParametrosClienteActiva.vue?vue&type=template&id=971b8b6c"
import script from "./ModalParametrosClienteActiva.vue?vue&type=script&lang=js"
export * from "./ModalParametrosClienteActiva.vue?vue&type=script&lang=js"
import style0 from "./ModalParametrosClienteActiva.vue?vue&type=style&index=0&id=971b8b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports